import React from "react";
import formatBRL from "../../../shared/utils/formatBRL";

/**
 * Card "Produtos mais vendidos" — `items` vem de topProducts() (top 10).
 * Fica na mesma linha dos gráficos e rola por dentro.
 */
const TopProductsList = ({ items = [] }) => (
  <section className="sales-card sales-top">
    <header className="sales-card__header">
      <h2 className="sales-card__title">Produtos mais vendidos</h2>
      {items.length > 0 && (
        <span className="sales-card__meta">Top {items.length}</span>
      )}
    </header>

    {items.length === 0 ? (
      <p className="sales-empty">Sem vendas nesse período.</p>
    ) : (
      <div className="sales-top__scroll">
        <table className="sales-top__table">
          <thead>
            <tr>
              <th>Produto</th>
              <th className="is-right">Qtd</th>
              <th className="is-right">Receita</th>
            </tr>
          </thead>
          <tbody>
            {items.map((p, i) => (
              <tr key={p.id}>
                <td>
                  <div className="sales-top__product">
                    <span className="sales-top__rank">{i + 1}</span>
                    {p.image ? (
                      <img
                        src={p.image}
                        alt={p.name}
                        className="sales-top__thumb"
                      />
                    ) : (
                      <span className="sales-top__thumb" />
                    )}
                    <div>
                      <strong title={p.name}>{p.name}</strong>
                      {p.color && <small>{p.color}</small>}
                    </div>
                  </div>
                </td>
                <td className="is-right">{p.quantity}</td>
                <td className="is-right">{formatBRL(p.revenue)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )}
  </section>
);

export default TopProductsList;
